import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {},
  textFieldContainer: {},
  emailFieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  verifiedLabel: {
    color: theme.palette.success?.main || theme.palette.primary.main,
  },
  emailWarningIcon: {
    marginRight: theme.spacing(0.5),
  },
  emailVerifiedIcon: {
    marginRight: theme.spacing(0.5),
  },
  verifyEmailButton: {
    marginTop: theme.spacing(1),
  },
  saveButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    paddingTop: theme.spacing(2),
  },
}));
